import { Link, useLocation } from "react-router-dom";
import * as React from "react";
import { ChevronDown, Menu } from "lucide-react";
import { useContactModal } from "../context/contactModal";
import { COMPANY_LINKS } from "../data/navigation";
import { PRODUCT_GROUPS, getProduct } from "../data/products";
// Layout effect in the browser, plain effect during prerendering (avoids SSR warnings).
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;

export function Header({ forceLight = false }) {
  const { openModal } = useContactModal();
  const { pathname } = useLocation();
  const [r, i] = React.useState(false);
  const [o, s] = React.useState(null);
  const l = React.useRef(null);
  const c = React.useRef(null);
  const u = React.useRef(null);
  const f = React.useRef(null);
  const d = React.useRef(null);
  const h = React.useRef(null);
  const g = React.useRef(new Map());
  const x = React.useRef([]);
  const w = (b) => {
    var j;
    var S;
    d.current = ((j = f.current) == null ? undefined : j.getBoundingClientRect()) ?? null;
    g.current = new Map(
      Array.from(
        ((S = f.current) == null
          ? undefined
          : S.querySelectorAll(
              ".floating-left > button, .floating-left > a, .floating-right > button, .floating-right > a",
            )) ?? [],
      ).map((P) => [P, P.getBoundingClientRect()]),
    );
    s((P) => (P === b ? null : b));
  };
  useIsomorphicLayoutEffect(() => {
    var P;
    var C;
    const b = f.current;
    const j = d.current;
    d.current = null;
    if ((P = h.current) != null) {
      P.cancel();
    }
    x.current.forEach((N) => N.cancel());
    x.current = [];
    if (!b || !j || matchMedia("(prefers-reduced-motion:reduce)").matches) {
      return;
    }
    const S = b.getBoundingClientRect();
    if (matchMedia("(min-width:1025px)").matches) {
      g.current.forEach((N, A) => {
        const z = A.getBoundingClientRect();
        const G = N.left - z.left - (S.width - j.width);
        const X = N.top - z.top;
        x.current.push(
          A.animate(
            [
              {
                transform: `translate(${G}px, ${X}px)`,
              },
              {
                transform: "translate(0, 0)",
              },
            ],
            {
              duration: 320,
              easing: "cubic-bezier(.22,1,.36,1)",
            },
          ),
        );
      });
      h.current = b.animate(
        [
          {
            width: `${j.width}px`,
            height: `${j.height}px`,
          },
          {
            width: `${S.width}px`,
            height: `${S.height}px`,
          },
        ],
        {
          duration: 320,
          easing: "cubic-bezier(.22,1,.36,1)",
        },
      );
    }
    if ((C = b.querySelector(".floating-panel")) != null) {
      C.animate(
        [
          {
            opacity: 0,
            transform: "translateY(8px)",
          },
          {
            opacity: 1,
            transform: "translateY(0)",
          },
        ],
        {
          duration: 280,
          easing: "ease-out",
        },
      );
    }
  }, [o]);
  React.useEffect(
    () => () => {
      var b;
      if ((b = h.current) != null) {
        b.cancel();
      }
      x.current.forEach((j) => j.cancel());
    },
    [],
  );
  const k = React.useRef();
  const m = () => {
    clearTimeout(k.current);
    i(false);
    s(null);
  };
  const p = () => {
    clearTimeout(k.current);
    if (matchMedia("(min-width:1025px) and (hover:hover)").matches) {
      i(true);
    }
  };
  const y = () => {
    if (matchMedia("(min-width:1025px) and (hover:hover)").matches) {
      k.current = setTimeout(m, 180);
    }
  };
  React.useEffect(() => () => clearTimeout(k.current), []);
  React.useEffect(m, [pathname]);
  React.useEffect(() => {
    if (!r) {
      return;
    }
    const b = matchMedia("(max-width:1024px)");
    const j = document.body.style.overflow;
    const S = () => {
      document.body.style.overflow = b.matches ? "hidden" : j;
    };
    const P = (C) => {
      var G;
      if (C.key !== "Tab" || !b.matches) {
        return;
      }
      const N = Array.from(
        ((G = l.current) == null ? undefined : G.querySelectorAll("a[href],button:not([disabled])")) || [],
      ).filter((X) => X.tabIndex >= 0 && X.getClientRects().length > 0);
      const A = N[0];
      const z = N[N.length - 1];
      if (C.shiftKey && document.activeElement === A) {
        C.preventDefault();
        if (z != null) {
          z.focus();
        }
      } else if (!C.shiftKey && document.activeElement === z) {
        C.preventDefault();
        if (A != null) {
          A.focus();
        }
      }
    };
    S();
    b.addEventListener("change", S);
    document.addEventListener("keydown", P);
    return () => {
      document.body.style.overflow = j;
      b.removeEventListener("change", S);
      document.removeEventListener("keydown", P);
    };
  }, [r]);
  React.useEffect(() => {
    const b = (S) => {
      var P;
      if ((P = l.current) == null || !P.contains(S.target)) {
        m();
      }
    };
    const j = (S) => {
      var P;
      var C;
      if (S.key === "Escape") {
        if ((P = l.current) != null && P.contains(document.activeElement)) {
          if ((C = u.current) != null) {
            C.focus();
          }
        }
        m();
      }
    };
    document.addEventListener("pointerdown", b);
    document.addEventListener("keydown", j);
    return () => {
      document.removeEventListener("pointerdown", b);
      document.removeEventListener("keydown", j);
    };
  }, []);
  return (
    <header ref={l} className={`floating-header ${forceLight ? "" : "on-dark"} ${r ? "is-expanded" : ""}`}>
      <div className="floating-shell" />
      <Link
        ref={c}
        to="/"
        className="floating-logo"
        aria-label="Actrium AI home"
        onClick={() => {
          m();
          window.scrollTo({
            top: 0,
            behavior: "auto",
          });
        }}
      >
        <span className="floating-logo-clip">
          <img src="/assets/images/actrium_logo.svg" alt="" />
        </span>
      </Link>
      <button
        ref={u}
        className="floating-menu-toggle"
        onMouseEnter={p}
        onMouseLeave={y}
        aria-label={r ? "Close navigation" : "Open navigation"}
        aria-expanded={r}
        aria-controls="floating-navigation"
        onClick={() => {
          if (r) {
            m();
          } else {
            i(true);
          }
        }}
      >
        <Menu size={20} className="menu-morph" aria-hidden="true" />
      </button>
      <nav
        ref={f}
        id="floating-navigation"
        className="floating-navigation"
        onMouseEnter={p}
        onMouseLeave={y}
        aria-label="Main navigation"
        aria-hidden={!r}
      >
        <div className="floating-left">
          <button
            tabIndex={r ? 0 : -1}
            aria-expanded={o === "products"}
            aria-controls="floating-products"
            onClick={() => w("products")}
          >
            Products <ChevronDown size={16} />
          </button>
          {o === "products" && (
            <div id="floating-products" className="floating-panel">
              <Link className="floating-all" to="/products">
                All Products
              </Link>
              <div className="floating-product-groups">
                {PRODUCT_GROUPS.map((b) => (
                  <div key={b.name}>
                    <h2>{b.path ? <Link to={b.path}>{b.name}</Link> : b.name}</h2>
                    {b.slugs.map((j) => {
                      var S;
                      return (
                        <Link to={`/products/${j}`} key={j}>
                          {(S = getProduct(j)) == null ? undefined : S.name}
                        </Link>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
          )}
          <Link tabIndex={r ? 0 : -1} to="/solutions">
            Solutions
          </Link>
          <Link tabIndex={r ? 0 : -1} to="/training">
            Training & Compute
          </Link>
        </div>
        <div className="floating-right">
          <Link tabIndex={r ? 0 : -1} to="/resources/integration">
            Resources
          </Link>
          <button
            tabIndex={r ? 0 : -1}
            aria-expanded={o === "company"}
            aria-controls="floating-company"
            onClick={() => w("company")}
          >
            Company <ChevronDown size={16} />
          </button>
          {o === "company" && (
            <div id="floating-company" className="floating-panel floating-company">
              {COMPANY_LINKS.map(([b, j]) => (
                <Link to={j} key={j}>
                  {b}
                </Link>
              ))}
            </div>
          )}
          <button
            tabIndex={r ? 0 : -1}
            className="floating-contact"
            onClick={() => {
              m();
              openModal();
            }}
          >
            Contact Sales
          </button>
        </div>
      </nav>
    </header>
  );
}
